import React, { useMemo } from "react";
import { Block } from "@randajan/jet-react/dom/block";
import { Caption } from "@randajan/jet-react/dom/caption";
import { Link } from "@randajan/jet-react/dom/link";

import { Locale } from "../../assets/Locale";

import "./HttpError.scss";

const getClassName = (...parts)=>parts.filter(Boolean).join(" ");

export const HttpError = (props)=>{
    const { action="pageE404Action", caption, className, desc, status=400, to="/" } = props;
    const enteredAt = useMemo(_=>new Date(), []);
    const say = Locale.use();

    return (
        <Block level={0} className={getClassName("HttpError", className)}>
            <div className="wall -gaps">
                <div className="header">
                    <span className="statusCode">{status}</span>
                    <span className="font -fade">{say.dateTime(enteredAt)}</span>
                </div>
                {caption ? <Caption>{say(caption)}</Caption> : null}
                {desc ? <p>{say(desc)}</p> : null}
                <div className="controls">
                    <Link className="-button" to={to}>{say(action)}</Link>
                </div>
            </div>
        </Block>
    );
};
